'use client';

import type { ReactNode } from 'react';

import { useLoyaltyContext } from '@libs/common-next';

export function OfferPattern({ children }: Readonly<{ children: ReactNode }>) {
    const { isLoyaltyUnavailable } = useLoyaltyContext();

    if (isLoyaltyUnavailable) {
        return null;
    }

    return children;
}
